module.exports = "<div>\n  <span class=\"icon icon-info\"></span>\n\n  <p ng-if=\"!$ctrl.simulationWitness\">\n    {{ 'LOANS.SIGN_UP.FORM_SIMULATION.HOUSING_CHANGE_WARNING' | translate }}\n  </p>\n\n  <p ng-if=\"$ctrl.simulationWitness\"\n     ng-bind-html=\"'LOANS.SIGN_UP.FORM_SIMULATION.SIMULATION_CHANGE_WARNING' | translate\">\n  </p>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/loans.module/features/loansSignUp/loansSignUpFormSimulation/loansSignUpFormSimulationHousingChangeWarning/loansSignUpFormSimulationHousingChangeWarning.html
// module id = 1922
// module chunks = 0